import { BroadcastStatus } from '../types/broadcast';

export const BROADCAST_STATUSES_ABLE_TO_END = new Set([
    BroadcastStatus.STARTED,
    BroadcastStatus.STARTING,
    BroadcastStatus.FINISHED,
]);
